import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';
import { Training } from '../models/training';
import { TrainingSearchResult } from '../models/trainingSearchResult';

export const getTraining = (trainingId: string): Promise<Training> => {
  return cacheableRequest(`/v1/search/${trainingId}`).then(({ data }: AxiosResponse<TrainingSearchResult>) => {
    return data;
  });
};
